import React from "react";

import styles from "./index.module.scss";
import { NewEventsItem, NewEventsItemProps } from "../news-events-item";
import { LearnMore } from "../learn-more";
import clsx from "clsx";

export interface NewsEventsItemsGroupProps {
  items: NewEventsItemProps[];
  onLoadMore?: (e: any) => void;
  loadMoreText?: string;
  loadMoreLink?: string;
  showLoadMore?: boolean;
  title?: string;
  className?: string;
  wrapperStyle?: React.CSSProperties;
}

export function NewsEventsItemsGroup(props: NewsEventsItemsGroupProps) {
  const {
    items,
    onLoadMore,
    loadMoreText = "查看更多",
    loadMoreLink = "/newsevents.html",
    showLoadMore = true,
    title = "活动看板",
    className,
    wrapperStyle
  } = props;

  return (
    <div className={clsx([styles.wrapper, className ?? ""])}>
      <div className={styles["title-wrapper"]}>
        <h2>{title}</h2>
      </div>

      <div className={styles["items-wrapper"]} style={wrapperStyle}>
        {items.map((item, index) => (
          <NewEventsItem
            key={index}
            title={item.title}
            time={item.time}
            image={item.image}
            link={item.link}
          />
        ))}
      </div>

      {showLoadMore ? (
        <div className={styles.more}>
          <LearnMore
            text={loadMoreText}
            link={loadMoreLink}
            onClick={onLoadMore}
          />
        </div>
      ) : null}
    </div>
  );
}
